import React from "react";
import { Button } from "@mui/material";

import UserEmailsTable from "./UserEmailsTable";
import { useUserData } from "../context/UserDataProvider";
import { FetchFunction } from "./FetchProvider";
import { FormattedMessage } from "react-intl";
import { TitledContent } from "./TitledContent";
import { useLoaderData, useRevalidator } from "react-router-dom";
import { ListRequest } from "../utils/crud";
import { fetchList } from "../utils/crud";
import CRUDFormDialog from "./CRUDFormDialog";

export async function accountEmailsLoader(fetch: FetchFunction, userId: number) {
    const req = new ListRequest("user_email", {
        filters: {
            operator: "==",
            column: "user_id",
            value: userId,
        },
    });

    const result = await fetchList(fetch, req);

    return result ? result.rows : [];
}

const AccountEmailsPage = () => {
    const emails: any = useLoaderData();
    const userData = useUserData();
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const revalidator = useRevalidator();

    return (
        <>
            <TitledContent
                title={<FormattedMessage id="account.emails" />}
                action={
                    <Button variant="contained" size="small" onClick={() => setDialogOpen(true)}>
                        <FormattedMessage id="user_email.create" />
                    </Button>
                }
            >
                <UserEmailsTable rows={emails} />
            </TitledContent>
            <CRUDFormDialog
                open={dialogOpen}
                titleId="user_email.create"
                hide={() => setDialogOpen(false)}
                action="create"
                resourceName="user_email"
                extraRequestData={{ user: userData.userId }}
                onSuccess={() => {
                    setDialogOpen(false);
                    revalidator.revalidate();
                }}
            />
        </>
    );
};

export default AccountEmailsPage;
